import { render } from "./AddEditStrykerCommand.vue?vue&type=template&id=13538dfd"
import script from "./AddEditStrykerCommand.vue?vue&type=script&lang=js"
export * from "./AddEditStrykerCommand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__